import { Link, useParams } from "react-router";
import { IconArrowLeft } from "@tabler/icons-react";
import { paths } from "@/App";
import AppHeader from "@/lib/components/AppHeader";
import NotificationsDropdown from "@/lib/components/NotificationsDropdown";
import { useSidebar } from "@/lib/components/Sidebar";
import { TUTORIALS } from "./tutorials";
import { useOpenedTutorialIds, useTutorialVideoDialog } from "./tutorial-hooks";
import VideoThumbnail from "@/lib/components/VideoThumbnail";

export default function TutorialsPage() {
  const { teamExternalId } = useParams();
  const { play, dialog } = useTutorialVideoDialog();
  const openedTutorialIds = useOpenedTutorialIds();
  const { isMobile } = useSidebar();

  return (
    <div className="overflow-y-auto">
      <AppHeader
        inlineActions
        actionChildren={!isMobile && <NotificationsDropdown />}
      >
        <Link
          to={paths.home(teamExternalId!)}
          className="flex w-fit items-center gap-2 text-sm text-text-secondary hover:text-text-primary"
        >
          <IconArrowLeft size={16} />
          Home
        </Link>
      </AppHeader>
      <h1 className="px-4 pt-2 pb-2 text-2xl font-semibold md:px-6">
        Learn Amplifiles
      </h1>
      <ul className="grid grid-cols-1 gap-x-6 gap-y-8 px-4 pt-6 pb-10 sm:grid-cols-2 md:px-6 xl:grid-cols-4">
        {TUTORIALS.map((tutorial) => (
          <li key={tutorial.id} className="min-w-0">
            <button
              onClick={() => play(tutorial)}
              className="group w-full cursor-pointer text-left"
            >
              <VideoThumbnail
                title={tutorial.title}
                imageSrc={tutorial.thumbnailSrc}
                minutes={tutorial.minutes}
                isOpened={openedTutorialIds?.includes(tutorial.id)}
              />
            </button>
          </li>
        ))}
      </ul>
      {dialog}
    </div>
  );
}
